import {getToken} from "./firebase";
import {callAuthApi} from "./api";
import {emailInput, passInput, togglePassButton, pwd, eyeOpen, eyeClosed} from "./dom";
import {setToLoading, disableLoading} from "./ui";


export default function INIT() {
    (document.getElementById("login-form") as HTMLFormElement).addEventListener("submit", signIn);
    togglePassButton.addEventListener('click', showHidePassword)
}

function showHidePassword() {
    const isHidden = pwd.type === 'password';
    pwd.type = isHidden ? 'text' : 'password';
    eyeOpen.classList.toggle('hidden', !isHidden);
    eyeClosed.classList.toggle('hidden', isHidden);
    togglePassButton.setAttribute('aria-pressed', String(!isHidden));

}

async function signIn(event: Event): Promise<void> {
    event.preventDefault();
    setToLoading();

    const email: string = emailInput.value;
    const pass: string = passInput.value;

    try {
        const token = await getToken(email, pass);
        const response = await callAuthApi(token);

        if (response.redirected) {
            window.location.href = response.url;
        } else {
            alert("Something went wrong... Try again later.");
            disableLoading();
        }
    } catch (e) {
        console.error(e);
        alert("Error signing in");
        disableLoading();
    }
}